var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#3B3D4B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 5.24927C4.49951 5.24927 1.49951 12 1.49951 12C1.49951 12 4.49951 18.7493 11.9995 18.7493C19.4995 18.7493 22.4995 12 22.4995 12C22.4995 12 19.4995 5.24927 11.9995 5.24927Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 15.7501C14.0706 15.7501 15.7495 14.0711 15.7495 12.0001C15.7495 9.92899 14.0706 8.25006 11.9995 8.25006C9.92844 8.25006 8.24951 9.92899 8.24951 12.0001C8.24951 14.0711 9.92844 15.7501 11.9995 15.7501Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3a76ba63.svg";
export { ForwardRef as ReactComponent };